import {TabsUrlState} from 'app/components/tabNavigation/interface';
import {Undef} from 'app/interface';
import {parseHashUrl} from 'app/utils/urlStateElements/parseHashUrl';

export function getHashState(hash: string, cId: string): Undef<TabsUrlState> {
    const hashState = parseHashUrl(hash);
    const componentState = hashState[cId];
    if (componentState === undefined) {
        return;
    }

    return {
        id: componentState.id,
    };
}
